import { IGetAllFornecedorUseCase } from "../../../presentation/useCases/read/get_all_fornecedor_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { FornecedorLista } from "../../models/fornecedor";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * GetAllFornecedorUseCase
 */

export class GetAllFornecedorUseCase extends BasePaginatedUseCase<FornecedorLista> implements IGetAllFornecedorUseCase {
  constructor(private readonly repository: IComprasRepository) {
    super();
  }

  async getAllFornecedor(
    razaoSocial: string | null,
    cnpj: string | null,
    cpf: string | null,
    nomeFantasia: string | null,
    centroCustos: number[] | null,
    familias: string[] | null,
    atividades: string[] | null,
    documento: number | null,
    tipoFornecedor: number | null,
    status: number | null,
    avaliacaoCentroCusto: number[] | null,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    const response = await this.repository.getAllFornecedor(
      razaoSocial ?? '',
      cnpj ? this.applyPartialMask(cnpj, '00.000.000/0000-00') : '',
      cpf ? this.applyPartialMask(cpf, '000.000.000-00') : '',
      nomeFantasia ?? '',
      centroCustos,
      familias,
      atividades,
      documento ?? 1,
      tipoFornecedor ?? 1,
      status ?? 1,
      avaliacaoCentroCusto,
      page,
      rowsPerPage,
    );

    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }

  applyPartialMask(value: string, mask: string): string {
    let masked = "";
    let vi = 0;

    for (let mi = 0; mi < mask.length; mi++) {
      const maskChar = mask[mi];
      if (maskChar === "0") {
        if (vi < value.length) {
          masked += value[vi];
          vi++;
        } else {
          break;
        }
      } else {
        if (vi < value.length) {
          masked += maskChar;
        } else {
          break;
        }
      }
    }
    return masked;
  }
}
